import { TypedPolicy } from '@/react/portainer/policies/types';
import { useDockerSetupInitialValues } from '@/react/portainer/policies/components/docker/setup/useDockerSetupInitialValues';

import { FormSection } from '@@/form-components/FormSection';

import { PolicyTableWrapper } from './PolicyTableWrapper';
import { SettingItem } from './SettingItem';

interface Props {
  policy: TypedPolicy<unknown>;
}

export function DockerSetupPolicyReadOnly({ policy }: Props) {
  const values = useDockerSetupInitialValues(policy);

  return (
    <div className="space-y-6">
      <FormSection title="Host and access settings">
        <div className="rounded-lg border border-gray-5 th-dark:border-gray-7 overflow-hidden">
          <SettingItem
            label="Enable host management features"
            value={values.enableHostManagementFeatures}
          />
          <SettingItem
            label="Allow volume browser for non-administrators"
            value={values.allowVolumeBrowserForRegularUsers}
          />
          <SettingItem
            label="Enable image update notifications"
            value={values.enableImageNotification}
          />
          <SettingItem
            label="Enable GPU management"
            value={values.enableGpuManagement}
          />
        </div>
      </FormSection>

      <FormSection title="Change Window">
        <div className="rounded-lg border border-gray-5 th-dark:border-gray-7 overflow-hidden">
          <SettingItem
            label="GitOps change window"
            value={values.changeWindow?.Enabled}
          />
          {values.changeWindow?.Enabled && (
            <div className="flex items-center justify-between py-3 px-4 bg-gray-2 th-dark:bg-gray-iron-10">
              <span className="text-sm">Window</span>
              <span className="text-sm font-medium">
                {values.changeWindow.StartTime} - {values.changeWindow.EndTime}
              </span>
            </div>
          )}
        </div>
      </FormSection>

      {values.enableGpuManagement && values.gpus.length > 0 && (
        <FormSection title="GPUs">
          <PolicyTableWrapper
            caption="Configured GPUs for this policy"
            data-cy="docker-setup-gpus-table"
          >
            <thead className="bg-gray-3 th-dark:bg-gray-9">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium">
                  Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-5 th-dark:divide-gray-7">
              {values.gpus.map((gpu) => (
                <tr key={`${gpu.name}-${gpu.value}`}>
                  <td className="px-4 py-3 text-sm">{gpu.name}</td>
                  <td className="px-4 py-3 text-sm">{gpu.value}</td>
                </tr>
              ))}
            </tbody>
          </PolicyTableWrapper>
        </FormSection>
      )}
    </div>
  );
}
